<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          <span class="text-lg font-semibold">Par Type de Page</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :sort-by="'count'"
            :sort-desc="true"
          >
            <template v-slot:item.content_type="{ item }">
              <a
                :href="`/web-perf/cwv-performance-breakdown?devices=15,16&dates=${start_date},${end_date}&sites=${site_id}&pageTypes=${item.content_type}`"
              >
                {{ item.content_type }}
              </a>
            </template>
            <template v-slot:item.lcp="{ item }">
              <status-card :type="'LCP'" :values="item.lcp" />
            </template>
            <template v-slot:item.cls="{ item }">
              <status-card :type="'CLS'" :values="item.cls" />
            </template>
            <template v-slot:item.inp="{ item }">
              <status-card :type="'INP'" :values="item.inp" />
            </template>
            <template v-slot:item.ttfb="{ item }">
              <status-card :type="'TTFB'" :values="item.ttfb" />
            </template>
            <template v-slot:item.fcp="{ item }">
              <status-card :type="'FCP'" :values="item.fcp" />
            </template>
            <template v-slot:item.count="{ item }">
              {{ formatNumber(item.count) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import StatusCard from "@/components/web-perf/cwv/cwv-sites-performance/cards/StatusCard.vue";
import { formatNumber } from "@/utils/formatting";

export default {
  name: "MetricsBreakdownCard",
  components: {
    StatusCard,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: "",
      loading: false,
      total: 0,
      headers: [
        { text: "Type de Page", value: "content_type" },
        { text: "LCP", value: "lcp" },
        { text: "CLS", value: "cls" },
        { text: "INP", value: "inp" },
        { text: "TTFB", value: "ttfb" },
        { text: "FCP", value: "fcp" },
        { text: "Events Count", value: "count" },
      ],
    };
  },
  methods: {
    formatNumber,
  },
  computed: {
    start_date() {
      return this.$store.getters["webPerf/getDates"][0];
    },
    end_date() {
      return this.$store.getters["webPerf/getDates"][1];
    },
    site_id() {
      return this.$store.getters["webPerf/getSites"][0] || "";
    },
  },
};
</script>
